import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useTrackingCodeFormField = ({ throttleValue }) => {
    const isTrackingCodeDefaultValueEmpty = useConfigMatch({ [FEATURE_FLAGS.IS_DEFAULT_TRACKING_CODE_EMPTY]: 'true' });

    const fieldProps = useFormFieldValue({ field: 'trackingCode', throttleValue }, { isTrackingCodeDefaultValueEmpty });
    return fieldProps;
};
